import styled from "styled-components";

export const LayoutOne = styled.div`
  padding: 12px 16px 40px;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 16px 24px 60px;
  }

  @media (min-width: 1024px) {
    padding: 20px 32px 60px;
  }
`;

export const LayoutThree = styled.div`
  display: grid;
  grid-template-areas: "leftside main rightside";
  grid-template-columns: minmax(250px, 3fr) minmax(800px, 12fr) minmax(
      90px,
      2.5fr
    );
  column-gap: 30px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 100%;
  max-width: 1100px;
  margin: 25px auto;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 60px 0;
    width: 100%;
  }
`;
export const LayoutTwo = styled.div`
  display: grid;
  grid-template-areas: "leftside main";
  grid-template-columns: minmax(350px, 3fr) minmax(700px, 12fr);
  column-gap: 20px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 100%;
  max-width: 1100px;
  margin: 25px auto;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  padding-bottom: 60px;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 80px 0;
    width: 100%;
  }
`;
export const LayoutNarrowTwo = styled(LayoutTwo)`
  grid-template-columns: minmax(120px, 1fr) minmax(700px, 12fr);
`;

export const LayoutTwoR = styled.div`
  display: grid;
  grid-template-areas: "main rightside";
  grid-template-columns: minmax(1000px, 12fr) minmax(90px, 3fr);
  column-gap: 20px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 100%;
  max-width: 1100px;
  margin: 25px auto;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  padding-bottom: 60px;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 80px 0;
    width: 100%;
  }
`;
export const LayoutTwoScroll = styled(LayoutTwo)`
  overflow-y: hidden;
`;

export const LayoutAll = styled.div`
  width: 100%;
`;

export const LayoutHome = styled.div`
  display: grid;
  grid-template-areas: "leftside main";
  grid-template-columns: minmax(250px, 3fr) minmax(700px, 12fr);
  column-gap: 30px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 100%;
  max-width: 1100px;
  margin: 25px auto;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  padding-bottom: 60px;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 80px 0;
    width: 100%;
  }
`;

export const Button = styled.button`
  font-size: 0.97rem;
  min-width: 120px;
  padding: 8px 20px;
  margin-top: 10px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  background-color: ${(props) => (props.disabled ? "#9ca3af" : "#4f46e5")};
  color: white;
  margin-right: 10px;
  position: relative;
  transition: background-color 0.15s;

  &:hover {
    background-color: #4b4b4b44;
  }
  &:active {
    background-color: #0f0f0f44;
  }
`;
export const SmallButton = styled(Button)`
  padding: 2px 8px;
  font-size: 0.95rem;
`;
export const BlueButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#4f46e5")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#6366f1")};
  }
`;

export const GrayButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#e5e7eb" : "#f3f4f6")};
  color: #374151;
  border: 1px solid #e5e7eb;
  &:hover {
    background-color: #e5e7eb;
  }
`;
export const IndianRedButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "indianred")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#ec7575")};
  }
`;
export const OrangeButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "orange")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#ffc558")};
  }
`;
export const TomatoButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#4f46e5")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#6366f1")};
  }
`;
export const PurpleButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#e11d48")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#f43f5e")};
  }
`;
export const GreenButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "green")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#439943")};
  }
`;
export const NavyButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "navy")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#4a4a97")};
  }
`;
export const RedButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? "#9e9d9d" : "red")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#9e9d9d" : "#ff6a6a")};
  }
`;
export const SmallBlueButton = styled(SmallButton)`
  background-color: dodgerblue;
`;
export const SmallIndianRedButton = styled(SmallButton)`
  background-color: indianred;
`;
export const SmallOrangeButton = styled(SmallButton)`
  background-color: orange;
`;
export const SmallTomatoButton = styled(SmallButton)`
  background-color: tomato;
`;
export const SmallPurpleButton = styled(SmallButton)`
  background-color: purple;
`;
export const SmallNavyButton = styled(SmallButton)`
  background-color: navy;
`;
export const SmallRedButton = styled(SmallButton)`
  background-color: red;
`;
export const SmallLightGrayButton = styled(SmallButton)`
  background-color: lightgray;
  color: black;
`;

export type MaxHeightProps = {
  maxHeight?: string;
};

export type SelectedProps = {
  selected?: string;
};

export type WidthProps = {
  imageWidth?: number;
};

export type IsFullCenterProps = {
  isFullCenter?: boolean;
};

export type ExpandedProps = {
  isExpanded: boolean;
};

export type ActiveProps = {
  active: boolean;
};
